import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CRadioLabelHtmlComponent } from './c-radio-label-html.component';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { FetchImageFromHtmlModule } from 'src/app/pipes/fetch-image-from-html/fetch-image-from-html.module';
import { TrustHtmlModule } from 'src/app/pipes/trust-html/trust-html.module';
import { IsContainedInControlValuePipeModule } from 'src/app/pipes/is-contained-in-control-value-pipe/is-contained-in-control-value-pipe.module';

import { AsPipesModule } from '../../../pipes/as-pipes/as-pipes.module';

@NgModule({
  declarations: [CRadioLabelHtmlComponent],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    IonicModule,
    FetchImageFromHtmlModule,
    TrustHtmlModule,
    IsContainedInControlValuePipeModule,
    AsPipesModule,
  ],
  exports: [CRadioLabelHtmlComponent]
})
export class CRadioLabelHtmlModule { }
